/*
  Flechas para los carruseles del tema.

  Por qué existe: un carrusel que sólo se mueve con el dedo es una apuesta. En
  celulares reales el navegador puede quedarse con el gesto y la pista no se
  entera, aunque el CSS esté bien. Con flechas, el que quiere deslizar desliza y
  el que no, toca.

  Se monta desde JavaScript y los botones nacen ocultos: si el script no corre,
  no quedan botones muertos en la página. Y sólo aparecen cuando la pista
  realmente tiene contenido de sobra, así que en escritorio —donde estas
  secciones son grillas y no desplazan— no se ven.
*/
(function () {
  var PISTAS = [
    '.grilla__grid',
    '.resenas__pista',
    '.testcol__grid',
    '.citas__pista',
    '.sw-carousel-track',
  ];

  // Cuánto avanza cada toque: una tarjeta más la separación.
  function paso(pista) {
    var hijo = pista.firstElementChild;
    if (!hijo) return Math.round(pista.clientWidth * 0.8);
    var estilo = getComputedStyle(pista);
    var hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
    return Math.round(hijo.getBoundingClientRect().width + hueco);
  }

  function crearBoton(sentido) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'carrnav__btn carrnav__btn--' + sentido;
    b.setAttribute('aria-label', sentido === 'anterior' ? 'Ver anterior' : 'Ver siguiente');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      (sentido === 'anterior'
        ? '<path d="M15.5 4.5 8 12l7.5 7.5"/>'
        : '<path d="M8.5 4.5 16 12l-7.5 7.5"/>') +
      '</svg>';
    b.hidden = true;
    return b;
  }

  function montar(pista) {
    if (pista.dataset.flechas) return;
    pista.dataset.flechas = '1';

    // Se envuelve la pista para tener dónde apoyar los botones sin tocar el
    // resto del marcado de la sección.
    var caja = document.createElement('div');
    caja.className = 'carrnav';
    pista.parentNode.insertBefore(caja, pista);
    caja.appendChild(pista);

    var ant = crearBoton('anterior');
    var sig = crearBoton('siguiente');
    caja.appendChild(ant);
    caja.appendChild(sig);

    ant.addEventListener('click', function () {
      pista.scrollBy({ left: -paso(pista), behavior: 'smooth' });
    });
    sig.addEventListener('click', function () {
      pista.scrollBy({ left: paso(pista), behavior: 'smooth' });
    });

    function refrescar() {
      var desplaza = pista.scrollWidth > pista.clientWidth + 4;
      var fin = pista.scrollWidth - pista.clientWidth - 4;
      ant.hidden = !desplaza || pista.scrollLeft <= 4;
      sig.hidden = !desplaza || pista.scrollLeft >= fin;
    }

    pista.addEventListener('scroll', refrescar, { passive: true });
    window.addEventListener('resize', refrescar);
    if (window.ResizeObserver) new ResizeObserver(refrescar).observe(pista);
    // Las imágenes cambian el ancho de la pista al terminar de cargar.
    window.addEventListener('load', refrescar);
    refrescar();
  }

  /*
    Las imágenes de una pista horizontal quedan fuera de la pantalla hacia el
    costado, así que el navegador no las pide y al deslizar aparecen en blanco.

    Precargarlas al abrir la página arregla el blanco pero sale caro: en el
    advertorial son cuatro pistas, una de ellas de catorce fotos que casi nadie
    mira, y la página terminaba pesando más que antes.

    Por eso se piden cuando la persona toca la pista por primera vez: al cargar
    no cuestan nada, y para cuando termina el gesto ya están. Se hace una sola
    vez por pista.
  */
  function precargarPista(pista) {
    if (pista.dataset.precargada) return;
    pista.dataset.precargada = '1';
    Array.prototype.forEach.call(pista.querySelectorAll('img[loading="lazy"]'), function (img) {
      img.loading = 'eager';
    });
  }

  function vigilarPistas() {
    var pistas = [];
    Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'), function (img) {
      for (var a = img.parentElement; a && a !== document.body; a = a.parentElement) {
        var ox = getComputedStyle(a).overflowX;
        if ((ox === 'auto' || ox === 'scroll') && a.scrollWidth > a.clientWidth + 8) {
          if (pistas.indexOf(a) < 0) pistas.push(a);
          return;
        }
      }
    });
    pistas.forEach(function (pista) {
      // No se adelanta nada al cargar: adelantar aunque fueran dos por pista
      // costaba 250 KB en el advertorial, que tiene cuatro. Está medido.

      var alTocar = function () { precargarPista(pista); };
      pista.addEventListener('touchstart', alTocar, { passive: true, once: true });
      pista.addEventListener('mouseenter', alTocar, { once: true });
      pista.addEventListener('scroll', alTocar, { passive: true, once: true });
    });
  }

  function iniciar() {
    PISTAS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), montar);
    });
  }

  if (document.readyState === 'complete') {
    setTimeout(vigilarPistas, 600);
  } else {
    window.addEventListener('load', function () {
      setTimeout(vigilarPistas, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  // El editor de temas recarga secciones sueltas sin recargar la página.
  document.addEventListener('shopify:section:load', iniciar);
})();
